module.exports = __webpack_public_path__ + "84c0c23cb680ecb117aedac35402c769.png";